import React from 'react';
import qs from 'qs';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import MarkdownPage from '../../components/MarkdownPage';
import docZH from './terms-zh.md';
import docZHHant from './terms-zh-hant.md';
import docEN from './terms-en.md';
import docES from './terms-es.md';

const Terms = ({ location }) => {
  const search = qs.parse(location.search.slice(1));
  const docs = {
    zh: docZH,
    en: docEN,
    es: docES,
    'zh-Hant-HK': docZHHant,
  };
  const url = docs[search && search.locale] || docZH;
  return <MarkdownPage url={url} />;
};

Terms.propTypes = {
  location: PropTypes.object.isRequired,
};

export default withRouter(Terms);
